import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, Product, ProductWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateProduct(): UseMutationResult<
  AxiosResponse<Product>,
  AxiosError<ErrorMessage>,
  Omit<ProductWrite, 'file'> & { file: File | null }
> {
  const queryClient = useQueryClient();

  const createProduct = (
    payload: Omit<ProductWrite, 'file'> & { file: File | null },
  ): Promise<AxiosResponse<Product>> => {
    const formData = new FormData();
    formData.append('file', payload.file || '');
    formData.append('price', payload.price.toString());
    formData.append('tax_rate', payload.taxRate || '');
    formData.append('is_favorite', payload.isFavorite.toString());
    formData.append('name', payload.name);
    formData.append('type', payload.type);
    formData.append('product_id', payload.productId);
    return client.post('products/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  return useMutation(createProduct, {
    onSuccess: () => {
      queryClient.invalidateQueries('products');
    },
  });
}
